var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function getAuthorizationHeader(authorization) {
    return typeof authorization === 'string'
        ? "Bearer ".concat(authorization)
        : "".concat(authorization.type, " ").concat(authorization.token);
}
export function fetchWithAuth(url_1, authorization_1, requestor_1) {
    return __awaiter(this, arguments, void 0, function (url, authorization, requestor, options) {
        var headers, response, responseText, err_1, message;
        if (options === void 0) { options = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    headers = __assign({ Authorization: getAuthorizationHeader(authorization), 'X-Requestor': requestor }, options.headers);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, fetch(url, __assign(__assign({}, options), { headers: headers }))];
                case 2:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.text()];
                case 3:
                    responseText = _a.sent();
                    throw new Error("Unknown error occurred. Response status: ".concat(response.status, ", with payload: ").concat(responseText));
                case 4: return [2 /*return*/, response];
                case 5:
                    err_1 = _a.sent();
                    message = void 0;
                    if (err_1 instanceof Error) {
                        message = err_1.message;
                    }
                    else {
                        message = "Unknown error occurred. ".concat(JSON.stringify(err_1));
                    }
                    throw new Error(message);
                case 6: return [2 /*return*/];
            }
        });
    });
}
export function fetchWithResponse(url_1, authorization_1, requestor_1) {
    return __awaiter(this, arguments, void 0, function (url, authorization, requestor, options) {
        var response, reponseObject;
        if (options === void 0) { options = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchWithAuth(url, authorization, requestor, options)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    reponseObject = _a.sent();
                    return [2 /*return*/, reponseObject];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmV0Y2hIdHRwQ2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ZldGNoSHR0cENsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVBLFNBQVMsc0JBQXNCLENBQUMsYUFBbUM7SUFDakUsT0FBTyxPQUFPLGFBQWEsS0FBSyxRQUFRO1FBQ3RDLENBQUMsQ0FBQyxpQkFBVSxhQUFhLENBQUU7UUFDM0IsQ0FBQyxDQUFDLFVBQUcsYUFBYSxDQUFDLElBQUksY0FBSSxhQUFhLENBQUMsS0FBSyxDQUFFLENBQUM7QUFDckQsQ0FBQztBQUVELE1BQU0sVUFBZ0IsYUFBYTt3REFDakMsR0FBVyxFQUNYLGFBQW1DLEVBQ25DLFNBQWlCLEVBQ2pCLE9BQXlCOztRQUF6Qix3QkFBQSxFQUFBLFlBQXlCOzs7O29CQUVuQixPQUFPLGNBQ1gsYUFBYSxFQUFFLHNCQUFzQixDQUFDLGFBQWEsQ0FBQyxFQUNwRCxhQUFhLEVBQUUsU0FBUyxJQUNyQixPQUFPLENBQUMsT0FBTyxDQUNuQixDQUFDOzs7O29CQUdpQixxQkFBTSxLQUFLLENBQUMsR0FBRyx3QkFBTyxPQUFPLEtBQUUsT0FBTyxTQUFBLElBQUcsRUFBQTs7b0JBQXBELFFBQVEsR0FBRyxTQUF5Qzt5QkFFdEQsQ0FBQyxRQUFRLENBQUMsRUFBRSxFQUFaLHdCQUFZO29CQUNPLHFCQUFNLFFBQVEsQ0FBQyxJQUFJLEVBQUUsRUFBQTs7b0JBQXBDLFlBQVksR0FBRyxTQUFxQjtvQkFFMUMsTUFBTSxJQUFJLEtBQUssQ0FDYixtREFBNEMsUUFBUSxDQUFDLE1BQU0sNkJBQW1CLFlBQVksQ0FBRSxDQUM3RixDQUFDO3dCQUdKLHNCQUFPLFFBQVEsRUFBQzs7O29CQUVaLE9BQU8sU0FBQSxDQUFDO29CQUNaLElBQUksS0FBRyxZQUFZLEtBQUssRUFBRSxDQUFDO3dCQUN6QixPQUFPLEdBQUcsS0FBRyxDQUFDLE9BQU8sQ0FBQztvQkFDeEIsQ0FBQzt5QkFBTSxDQUFDO3dCQUNOLE9BQU8sR0FBRyxrQ0FBMkIsSUFBSSxDQUFDLFNBQVMsQ0FBQyxLQUFHLENBQUMsQ0FBRSxDQUFDO29CQUM3RCxDQUFDO29CQUNELE1BQU0sSUFBSSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7Ozs7O0NBRTVCO0FBRUQsTUFBTSxVQUFnQixpQkFBaUI7d0RBQ3JDLEdBQVcsRUFDWCxhQUFtQyxFQUNuQyxTQUFpQixFQUNqQixPQUF5Qjs7UUFBekIsd0JBQUEsRUFBQSxZQUF5Qjs7O3dCQUVSLHFCQUFNLGFBQWEsQ0FBQyxHQUFHLEVBQUUsYUFBYSxFQUFFLFNBQVMsRUFBRSxPQUFPLENBQUMsRUFBQTs7b0JBQXRFLFFBQVEsR0FBRyxTQUEyRDtvQkFDdEQscUJBQU0sUUFBUSxDQUFDLElBQUksRUFBRSxFQUFBOztvQkFBckMsYUFBYSxHQUFHLFNBQXFCO29CQUMzQyxzQkFBTyxhQUFrQixFQUFDOzs7O0NBQzNCIn0=